import { Component, OnInit, Input, Output, ViewChild, AfterViewInit, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { DownloadExcelDialogComponent } from 'path-shared/components/dialogs/download-excel-dialog/download-excel-dialog.component';
import { Builder } from 'path-shared/models/builder';
import { MatPaginator, MatDialog, MatSort } from '@angular/material';
import { TipusVehicles } from '../../models/tipus-vehicles.model';
import { CustomDataSource } from 'path-shared/services/datasource/custom.datasource';
import { TipusVehiclesFilter } from '../../models/tipus-vehicles-filter';
import { TipusVehiclesService } from '../../services/tipus-vehicles.service';
import { FilterService } from 'path-shared/services/filter/filter.service';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { TipusVehiclesFilterService } from '../../services/tipus-vehicles-filter.service';
import { merge } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-tipus-vehicles-table',
  templateUrl: './tipus-vehicles-table.component.html',
  styleUrls: ['./tipus-vehicles-table.component.scss']
})
export class TipusVehiclesTableComponent implements OnInit, AfterViewInit, OnChanges {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  data: TipusVehicles[];
  dataSource: CustomDataSource<TipusVehicles, TipusVehiclesFilter>;
  filter: TipusVehiclesFilter = new TipusVehiclesFilter('descripcio', 'asc');
  displayedItems = [];
  highlightedRows = [];

  @Input() selectButton: boolean;
  @Input() updatedFilterData: TipusVehiclesFilter;
  @Output() notify: EventEmitter<number> = new EventEmitter<number>();
  @Output() itemClicked: EventEmitter<string> = new EventEmitter<string>();
  @Output() itemSelected: EventEmitter<string> = new EventEmitter<string>();

  displayedColumns = ['id', 'descripcio', 'matriculaObligatoria'];

  constructor(
    private tipusVehiclesService: TipusVehiclesService,
    private filterService: FilterService,
    private dialog: MatDialog,
    private i18n: I18n
  ) {
  }

  ngOnInit() {
    this.sort.disableClear = true;
    this.dataSource = CustomDataSource.create<TipusVehicles, TipusVehiclesFilter>(this.paginator, new TipusVehiclesFilterService(), 'urlGetTipusVehicles', 'urlGetTipusVehiclesCount');
    this.dataSource.subject.subscribe((data) => {
      data.forEach(item => {
        this.displayedItems[item.secureId] = {
          id: item.secureId
        };
      });
    });

    this.filter.filterUpdated.subscribe(updated => {
      if (updated) {
        this.load();
        if (!this.selectButton) { this.filterService.saveFilter('tipus-vehicles-filter', this.filter); }
      }
    });

    if (!this.selectButton) { this.filterService.loadFilter('tipus-vehicles-filter', this.filter); }
    this.filter.paginator.init(this.sort, this.paginator);
  }

  ngAfterViewInit() {
    // reset the paginator after sorting
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.filter.paginator.set(this.sort, this.paginator);
      this.filter.updated();
    });

    merge(this.sort.sortChange, this.paginator.page)
    .pipe(tap(() => this.filter.updated()))
    .subscribe();

    this.load();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.updatedFilterData != null) {
      this.update();
    }
  }

  update() {
    if (this.dataSource !== undefined) {
      this.updatedFilterData.paginator.set(this.sort, this.paginator);
      this.dataSource.loadFilter(this.updatedFilterData);
    }
  }

  load() {
    this.filter.paginator.set(this.sort, this.paginator);
    this.dataSource.loadFilter(this.filter);
  }

  onRowClicked(row) {
    this.itemClicked.next(row.secureId);
  }

  generateExcel(): void {
    let filter = this.filter;
    if (this.updatedFilterData != null) {
      filter = this.updatedFilterData;
    }
    this.dialog.open(DownloadExcelDialogComponent, {
        closeOnNavigation: false,
        autoFocus: true,
        data: Builder.newDownloadExcelDialogData (this.tipusVehiclesService, filter, this.i18n('Tipus Vehicles'), this.sort.direction, this.sort.active)
    });
  }

}
